import React from 'react';
import PropTypes from 'prop-types';

import {
  BarChart, LabelValue,
  List, PercentChart, PieChart, DetailsTable
} from '#/components/WidgetsTypes';
import styles from './styles.module.css';

const renderWidget = (ordination, exhibition, dashboardWidgetId, i, type, endpointUrl, endpointType, backgroundColor, fontColor, widgetBindDtos, auxiliaryOptionsDto) => {
  const types = {
    labelValue: <LabelValue ordination={ordination} dashboardWidgetId={dashboardWidgetId} id={i} endpoint={{ endpointUrl, endpointType }} bgColor={backgroundColor} fColor={fontColor} widgetBindDtos={widgetBindDtos} auxiliaryOptionsDto={auxiliaryOptionsDto} />,
    pieChart: <PieChart ordination={ordination} dashboardWidgetId={dashboardWidgetId} endpoint={{ endpointUrl, endpointType }} widgetBindDtos={widgetBindDtos} auxiliaryOptionsDto={auxiliaryOptionsDto}/>,
    barChart: <BarChart ordination={ordination} dashboardWidgetId={dashboardWidgetId} endpoint={{ endpointUrl, endpointType }} widgetBindDtos={widgetBindDtos} auxiliaryOptionsDto={auxiliaryOptionsDto}/>,
    basicList: <List exhibition={exhibition} ordination={ordination} dashboardWidgetId={dashboardWidgetId} endpoint={{ endpointUrl, endpointType }} widgetBindDtos={widgetBindDtos} widgetId={i} auxiliaryOptionsDto={auxiliaryOptionsDto}/>,
    percentChart: <PercentChart ordination={ordination} dashboardWidgetId={dashboardWidgetId} endpoint={{ endpointUrl, endpointType }} widgetBindDtos={widgetBindDtos} auxiliaryOptionsDto={auxiliaryOptionsDto}/>,
    detailsTable: <DetailsTable exhibition={exhibition} ordination={ordination} dashboardWidgetId={dashboardWidgetId} endpoint={{ endpointUrl, endpointType }} widgetBindDtos={widgetBindDtos} auxiliaryOptionsDto={auxiliaryOptionsDto} />,
  };
  return types[type];
};

function Widget({ data: { ordination, exhibition, dashboardWidgetId, i, title, type, endpointUrl, endpointType, defaultBackgroundColor, defaultFontColor, widgetBindDtos, auxiliaryOptionsDto } }) {
  return (
    <div className={styles.widgetCard} type={type}>
      <strong className={styles.title}>{title}</strong>
      {renderWidget(ordination, exhibition, dashboardWidgetId, i, type, endpointUrl, endpointType, defaultBackgroundColor, defaultFontColor, widgetBindDtos, auxiliaryOptionsDto)}
    </div>
  );
}

Widget.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Widget;
